import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from '../../service/helper/reduxHelper';
import { IPayRunExtraction } from '../../@types/model/payRunExtractions/payRunExtraction';

export default class PayRunExtractionActions {
    public static setIsLoading = createAction('PAY_RUN_EXTRACTION_SET_LOADING', withPayloadType<boolean>());
    public static setPayRunExtractionData = createAction('PAY_RUN_EXTRACTION_SET_LIST', withPayloadType<Array<IPayRunExtraction> | null>())
}